"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDescricaoDoErro = void 0;
/**
 * Função responsável por extrair o código (da exception no backend) através do JSON retornado pelo backend
 * **/
const parseCodigoDeErro = (data) => {
    if (data &&
        data.erros &&
        Array.isArray(data.erros) &&
        data.erros.length > 0 &&
        data.erros[0].codigo) {
        return data.erros[0].codigo;
    }
    else {
        return null;
    }
};
/**
 * Função responsável por extrair a descrição do erro através do JSON retornado pelo backend
 * **/
const parseDescricaoDoErro = (data) => {
    const codigoDoErro = parseCodigoDeErro(data);
    if (codigoDoErro) {
        return data.erros[0].descricao;
    }
    else {
        return null;
    }
};
/**
 * Função responsável por extrair descrição do erro a partir de um objeto de Error do axios
 * **/
const getDescricaoDoErro = (axiosError = undefined) => {
    const { response } = axiosError;
    if (!response) {
        return 'Não foi possível processar sua solicitação neste momento! (0)';
    }
    const { data } = response;
    const descricao = parseDescricaoDoErro(data);
    if (descricao) {
        return descricao;
    }
    else {
        const { status } = response;
        switch (status) {
            case 400:
                return 'Requisição incorreta! (400)';
            case 401:
                return 'Usuário não autenticado! (401)';
            case 403:
                return 'Usuário não possui permissão para acessar este recurso! (403)';
            case 404:
                return 'Recurso não encontrado! (404)';
            case 500:
            default:
                return 'Não foi possível processar sua solicitação neste momento! (500)';
        }
    }
};
exports.getDescricaoDoErro = getDescricaoDoErro;
//# sourceMappingURL=errorHandler.js.map